/* eslint-disable import/no-duplicates */
import Contact from '@atom-web/icons-24/Contact'
import Email from '@atom-web/icons-24/Email'
import Facebook from '@atom-web/icons-24/Facebook'
import Instagram from '@atom-web/icons-24/Instagram'
import Link from '@atom-web/icons-24/Link'
import Linkedin from '@atom-web/icons-24/Linkedin'
import Twitter from '@atom-web/icons-24/Twitter'
import Whatsapp from '@atom-web/icons-24/Whatsapp'
import { Text } from '@atom-web/micros'

export const brandContent = [
	"Pickyourtrail is India's leading online travel company that delivers tailor-made international holidays. Pickyourtrail aims to change the customer experience so they can explore destinations at their own pace with completely customized tour packages. Our unique matching algorithm and price comparison engine ensures that travellers build their itinerary completely suited to their tastes and at the best online prices. Pickyourtrail's intelligent platform helps save time and effort, without having to wait for a travel agent's quote, yet letting you have the fun of planning your own trip!",
	'Over the years, we have helped more than 10000+ travellers from across 14 countries explore their dream international holiday destinations. Pickyourtrail has the highest Five-star rating on Facebook by travellers, making us a top rated trip planner in India. We are an Amadeus Next incubated start-up and one of the top 6 finalists of the prestigious APAC Travel Innovation Summit award.',
]

export const packages = [
	{
		key: '1',
		category: 'Tour Packages',
		contents: [
			{
				name: 'Bali Tour Packages',
				url: '/packages/bali',
			},
			{
				name: 'Dubai Tour Packages',
				url: '/packages/dubai',
			},
			{
				name: 'Europe Tour Packages',
				url: '/packages/europe',
			},
			{
				name: 'Greece Tour Packages',
				url: '/packages/greece',
			},
			{
				name: 'Maldives Tour Packages',
				url: '/packages/maldives',
			},
			{
				name: 'Mauritius Tour Packages',
				url: '/packages/mauritius',
			},
			{
				name: 'Sri Lanka Tour Packages',
				url: '/packages/sri-lanka',
			},
			{
				name: 'Thailand Tour Packages',
				url: '/packages/thailand',
			},
			{
				name: 'Turkey Tour Packages',
				url: '/packages/turkey',
			},
			{
				name: 'Switzerland Tour Packages',
				url: '/packages/switzerland',
			},
			{
				name: 'Spain Tour Packages',
				url: '/packages/spain',
			},
			{
				name: 'Italy Tour Packages',
				url: '/packages/italy',
			},
			{
				name: 'UK Tour Packages',
				url: '/packages/united-kingdom',
			},
		],
	},
	{
		key: '2',
		category: 'Honeymoon Packages',
		contents: [
			{
				name: 'Bali Honeymoon Packages',
				url: '/honeymoon-packages/bali',
			},
			{
				name: 'Dubai Honeymoon Packages',
				url: '/honeymoon-packages/dubai',
			},
			{
				name: 'Europe Honeymoon Packages',
				url: '/honeymoon-packages/europe',
			},
			{
				name: 'Greece Honeymoon Packages',
				url: '/honeymoon-packages/greece',
			},
			{
				name: 'Maldives Honeymoon Packages',
				url: '/honeymoon-packages/maldives',
			},
			{
				name: 'Mauritius Honeymoon Packages',
				url: '/honeymoon-packages/mauritius',
			},
			{
				name: 'Sri Lanka Honeymoon Packages',
				url: '/honeymoon-packages/sri-lanka',
			},
			{
				name: 'Thailand Honeymoon Packages',
				url: '/honeymoon-packages/thailand',
			},
			{
				name: 'Turkey Honeymoon Packages',
				url: '/honeymoon-packages/turkey',
			},
			{
				name: 'Switzerland Honeymoon Packages',
				url: '/honeymoon-packages/switzerland',
			},
			{
				name: 'Spain Honeymoon Packages',
				url: '/honeymoon-packages/spain',
			},
			{
				name: 'Italy Honeymoon Packages',
				url: '/honeymoon-packages/italy',
			},
			{
				name: 'UK Honeymoon Packages',
				url: '/honeymoon-packages/united-kingdom',
			},
		],
	},
	{
		key: '3',
		category: 'Packages by Interest',
		contents: [
			{
				name: 'Honeymoon Packages',
				url: '/honeymoon-packages',
			},
			{
				name: 'Family Packages',
				url: '/family-packages',
			},
			{
				name: 'Budget Packages',
				url: '/budget-packages',
			},
			{
				name: 'Luxury Packages',
				url: '/luxury-packages',
			},
		],
	},
	{
		key: '4',
		category: 'Packages by City',
		contents: [
			{
				name: 'Packages from Chennai',
				url: '/packages-from-chennai',
			},
			{
				name: 'Packages from Mumbai',
				url: '/packages-from-mumbai',
			},
			{
				name: 'Packages from Delhi',
				url: '/packages-from-delhi',
			},
			{
				name: 'Packages from Bangalore',
				url: '/packages-from-bengaluru',
			},
			{
				name: 'Packages from Pune',
				url: '/packages-from-pune',
			},
			{
				name: 'Packages from Ahmedabad',
				url: '/packages-from-ahmedabad',
			},
			{
				name: 'Packages from Hyderabad',
				url: '/packages-from-hyderabad',
			},
		],
	},
]

export const pytLinks = [
	{
		key: '5',
		category: 'Pickyourtrail',
		contents: [
			{
				name: 'About Us',
				url: '/about-us',
			},
			{
				name: 'Careers',
				url: '/careers',
			},
			{
				name: 'Blog',
				url: '/blog/?cpid=footer',
			},
			{
				name: 'Testimonials',
				url: '/testimonials',
			},
			{
				name: 'Guides',
				url: '/guides',
			},
			{
				name: 'Visa',
				url: 'https://visa.pickyourtrail.com/',
			},
			{
				name: 'Press',
				url: '/press',
			},
		],
	},
	{
		key: '6',
		category: 'Policy',
		contents: [
			{
				name: 'Frequently asked questions',
				url: '/faq',
			},
			{
				name: 'Terms & Conditions',
				url: '/terms-and-conditions',
			},
			{
				name: 'Privacy',
				url: '/privacy-policy',
			},

			{
				name: 'Cancellations',
				url: '/cancellation-policy',
			},
			{
				name: 'Sitemap',
				url: '/all',
			},
			{
				name: 'Contact Us',
				url: '/contact-us',
			},
		],
	},
]

export const socialContent = [
	{
		name: 'Facebook',
		url: 'https://www.facebook.com/Pickyourtrail/reviews',
		icon: <Facebook fill="#fff" />,
	},
	{
		name: 'Twitter',
		url: 'https://twitter.com/@pickyourtrail',
		icon: <Twitter fill="#fff" />,
	},
	{
		name: 'Instagram',
		url: 'https://www.instagram.com/pickyourtrail/',
		icon: <Instagram fill="#fff" />,
	},
	{
		name: 'LinkedIn',
		url: 'https://www.linkedin.com/company/pickyourtrail/?originalSubdomain=in',
		icon: <Linkedin fill="#fff" />,
	},
	{
		name: 'Youtube',
		url: 'https://www.youtube.com/Pickyourtrail',
		icon: <Link fill="#fff" />,
	},
]

export const pytSection = [
	...pytLinks,
	{
		key: '7',
		category: 'Talk to us',
		contents: [
			{
				name: 'planners@pickyourtrail.com',
				url: 'mailto:planners@pickyourtrail.com',
				icon: <Email fill="#fff" />,
			},
			{
				name: '+919360991166',
				url: 'tel: +919360991166',
				icon: <Contact fill="#fff" />,
			},
			{
				name: '+919080601268',
				url: 'https://wa.me/+919080601268',
				icon: <Whatsapp fill="#fff" />,
			},
		],
	},
	{
		key: '8',
		category: 'Social',
		contents: socialContent,
		extras: (
			<Text
				size="3"
				css={{
					lineHeight: '$4',
				}}
			>
				Travel Troops Global Private Ltd. © {new Date().getUTCFullYear()} all
				rights reserved.
			</Text>
		),
	},
]

export const menuLinks = [
	{
		text: 'Testimonials',
		link: '/testimonials',
	},
	{
		text: 'Visa',
		link: 'https://visa.pickyourtrail.com/',
	},
	{
		text: 'FAQ',
		link: '/faq',
	},
	{
		text: 'Contact Us',
		link: '/contact-us',
	},
	{
		text: 'Guides',
		link: '/guides',
	},
	{
		text: 'Blog',
		link: '/blog',
	},
	{
		text: 'About Us',
		link: '/about-us',
	},
]
